const scheduledPaymentHasChangedReducer = (state = false, action) => {
	switch(action.type){
	case 'SCHEDULEDPAYMENTCHANGED':	
		return true;
	case 'SCHEDULEDPAYMENTNOTCHANGED':
		return false;
	default:
		return state;
	}
}

export default scheduledPaymentHasChangedReducer;